import { ICarrierLocation, ICarrierLocationPersistence } from '../interfaces';

export class CarrierLocationMapper {
  public static toDomain(raw: ICarrierLocationPersistence): ICarrierLocation {
    return {
      id: raw.id,
      address: raw.address || '',
      name: raw.name,
      lat: raw.lat,
      lng: raw.lng,
      mapUrl: raw.map_url || '',
      scheduleDescription: raw.schedule_description || '',
      branchStatus: raw.branch_status,
    };
  }
}
